export const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const regexPhone = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{1,4})(?: *x(\d+))?\s*$/
